import { UnifiedSearch } from './global-search/UnifiedSearch';

export function AppHeader() {
  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center h-16">
          {/* Global admin search — sidebar carries the brand + nav, so the
              header is just the search input. Hidden on small viewports
              where it would crowd the header; the same component is still
              usable from the (now thin) /admin-v2 page. */}
          <div className="hidden md:flex flex-1">
            <UnifiedSearch dense width="100%" />
          </div>
        </div>
      </div>
    </header>
  );
}
